"use client";

import { useEffect, useState } from "react";

export function useDeferredStartup(delayMs = 2000) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    let timer = 0;
    const start = () => {
      timer = window.setTimeout(() => setReady(true), delayMs);
    };

    if (document.readyState === "complete") {
      start();
    } else {
      window.addEventListener("load", start, { once: true });
    }

    return () => {
      window.removeEventListener("load", start);
      if (timer) window.clearTimeout(timer);
    };
  }, [delayMs]);

  return ready;
}
